import { FEATURED } from "../data/restaurant";
import { Reveal, Stagger, StaggerItem } from "./motion/Reveal";
import { BrushUnderline } from "./BrushHeading";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="max-w-3xl">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border-2 border-jet bg-cream px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] text-crimson shadow-hard-sm sm:text-sm">
            Gallery
          </p>
          <h2 className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-jet sm:text-5xl">
            Fresh from <BrushUnderline>our kitchen</BrushUnderline>
          </h2>
        </Reveal>

        <Stagger className="mt-12 columns-2 gap-5 md:columns-3 [&>*]:mb-5">
          {FEATURED.map((dish, i) => (
            <StaggerItem key={dish.name} className="break-inside-avoid">
              <figure
                data-testid="gallery-item"
                className={`group overflow-hidden rounded-3xl border-[3px] border-jet bg-cream shadow-hard-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-hard ${
                  i % 3 === 1 ? "md:rotate-1" : "md:-rotate-1"
                } hover:rotate-0`}
              >
                <div className="overflow-hidden">
                  <img
                    src={dish.img}
                    alt={`${dish.name} — ${dish.price}`}
                    className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <figcaption className="flex items-center justify-between gap-2 px-4 py-3">
                  <span className="truncate font-display text-sm font-extrabold uppercase text-jet">{dish.name}</span>
                  <span className="shrink-0 font-display text-sm font-black text-crimson">{dish.price}</span>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
